import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import './aboutus.css'

const markdown = `

### Project overview

Yao Zhou, Zhiyang Zhang, Zhigui Bao, Hongbo Li, Yaqing Lyu, Yanjun Zan, Yaoyao Wu, Lin Cheng, Yuhan Fang, Kun Wu, Jinzhe Zhang, Hongjun Lyu, Tao Lin, Qiang Gao, Surya Saha, Lukas Mueller, Zhangjun Fei, Thomas Städler, Shizhong Xu, Zhiwu Zhang, Doug Speed, Sanwen Huang

The Sanwen Huang lab at Agricultural Genomics Institute at Shenzhen, Chinese Academy of Agricultural Sciences presents tomato graph pangenome (TGG) by integrating 838 genomes, including 32 new reference-level genome assemblies. All related data are provided as listed:

HiFi assemblies (32 accessions, including SL5.0) [http://solomics.agis.org.cn/tomato/ftp/genome/]

Genome annotation (46 accessions) [http://solomics.agis.org.cn/tomato/ftp/gff/] 

TGG1.0 (vg format) [http://solomics.agis.org.cn/tomato/ftp/TGG1.0/]

TGG1.1 (vg format) [http://solomics.agis.org.cn/tomato/ftp/TGG1.1/]

TGG1.1 (vcf format) [http://solomics.agis.org.cn/tomato/ftp/TGG1.1-VCF/]

SV chip [http://solomics.agis.org.cn/tomato/ftp/SV_array/]

ID convertor (http://solomics.agis.org.cn/tomato/tool/id_converter)

**HiFi assemblies**: The preliminary genome assemblies including SL5.0 Heinz 1706 are generated with the \`Flye\` (v2.7), \`Hicanu\` (v2.0), and \`Hifiasm\` (v0.13), then the potential mis-assemblies are corrected by the \`GALA\`. For the scaffolding, the contigs of SL5.0 Heinz 1706 are ordered by Hi-C data. The remaining assemblies are anchored to chromosome with \`RagTag\` (v1.0.1). 

**Genome annotation**: 1) Gene structure annotation files: Intergrating repeat elements annotation, homology-based prediction, Ab initio prediction followed our pipeline. 2) Gene function annotation files: Aligning proteins to \`UniProtKB/SwissProt\` and \`InterProScan\` database.

**TGG1.0**: To get comprehensive variants for constructing tomato graph pangenome (TGG1.0), the above 31 individuals SVs vcf and SVs from previous 100 tomato accessions are merged and filltered redundant SVs following \`vg\` pipeline.  The 31 individuals SNPs and indels vcf are integrated with SVs vcf by \`bcftools\`.  TGG1.0 is constructed by these variants using \`vg\`.

**706 SNPs/InDels and SVs**: Short reads from 706 tomato accessions are mapped to TGG1.0  using \`vg girrafe\`, and  SNPs and Indels were called by \`DeepVariant\` (v1.0.0). 

**TGG1.1**: All the variants used for the construction of TGG1.0 and the SNPs and InDels called from the 706 accessions were integrated and used to construct TGG1.1.

**706 SVs**: SVs for the 706 accessions were genotyped by \`Paragraph\`.

**TGG1.1-332**: Short reads of 332 tomato accessions are mapped to TGG1.1 and genotyped according to above methods.

**Metabolites content**: The metabolites are download from previous study.

**Raw gene expression**: The expression traits are calculated using the software \`Kallisto\` (v0.46.2).

**SV chip**: SV panel (20,955) selected for DNA capture array

**ID convertor**: The gene ID in SL5.0 is not consitant with SL4.0 and a convertor is implemented in solomics website.`

class Aboutus extends React.Component {
    render() {
        return (
            <>
                <h2 style={{textAlign:'center'}}>Tomato graph pangenome project</h2>
                <ReactMarkdown children={markdown} remarkPlugins={[remarkGfm]}></ReactMarkdown>
            </>
        )
    }
}

export default Aboutus